import './product-card.styles.scss';
import { useContext } from 'react';
import { CartContext } from '../../components/context/cart.context.jsx';


import Button from '../button/button.component';

const ProductCard = ({ product }) => {
  const { name, price, imageUrl } = product;
  const { addItemToCart } = useContext(CartContext);
  const addProductToCart = () => addItemToCart(product);
  return (
    <div className='product-card-container'>
      <img src={imageUrl} alt={`${name}`} />
      <div className='footer'>
        <span className='name'>{name}</span>
        <span className='price'>{price}€</span>
      </div>
      <Button buttonType='inverted' onClick={addProductToCart}>
      Añadir al carrito</Button>
    </div>
  );
};

export default ProductCard;
